import { BaseObject } from '../_models/base-object';
import { BaseProductTankFormGroupMapper } from './base-product-tank-form-group.mapper';

// TODO why is this empty
export class ProductTankFormGroupMapper extends BaseProductTankFormGroupMapper {
  override map(source: BaseObject, destination: BaseObject) {
    super.map(source, destination);
  }
}
